import { useParams } from "react-router-dom";
import {
  FiArrowLeft,
  FiCheckCircle,
  FiStar,
} from "react-icons/fi";
import { productData } from "../Pages/Products";
import { Link } from "react-router-dom";

const DetailPage = () => {
  const { id } = useParams();
  const product = productData[id];

  if (!product) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-600">
        <p>Product not found.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-10">
        <div className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            <Link
              to="/#products"
              className="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
            >
              <FiArrowLeft className="mr-2" />
              <span className="hidden sm:inline">Back to Products</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-b from-blue-50 to-white py-12">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row gap-12">
            <div className="md:w-1/2">
              <div className="bg-white rounded-2xl shadow-xl p-6">
                <img
                  src={product.image}
                  alt={product.alt}
                  className="w-full h-auto object-contain rounded-lg"
                />
              </div>

              {/* Rating */}
              {product.rating && (
                <div className="mt-6 flex items-center">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <FiStar
                        key={i}
                        className={`${
                          i < Math.floor(product.rating)
                            ? "text-yellow-400"
                            : "text-gray-300"
                        } w-5 h-5`}
                        fill={
                          i < Math.floor(product.rating)
                            ? "currentColor"
                            : "none"
                        }
                      />
                    ))}
                  </div>
                  <span className="ml-2 text-gray-600">
                    {product.rating} ({Math.floor(product.rating * 20)} reviews)
                  </span>
                </div>
              )}
            </div>

            <div className="md:w-1/2">
              <div className="mb-4">
                <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full uppercase font-semibold tracking-wide">
                  {product.category}
                </span>
              </div>

              <h1 className="text-4xl font-bold text-gray-900 mb-4">
                {product.name}
              </h1>

              <p className="text-xl text-gray-600 mb-6">
                {product.description}
              </p>

              {product.price && (
                <div className="mb-8">
                  <span className="text-3xl font-bold text-gray-900">
                    {product.price}
                  </span>
                </div>
              )}

              <div className="mt-6">
                <a
                  href="https://wa.me/6281234567890"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full text-center bg-blue-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium transition-colors shadow-md"
                >
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container mx-auto px-6 py-12">
        <div className="flex flex-col lg:flex-row gap-12">
          {/* Left Column */}
          <div className="lg:w-2/3">
            {/* Features */}
            {product.features?.length > 0 && (
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200">
                  Key Features
                </h2>
                <div className="grid md:grid-cols-2 gap-6">
                  {product.features?.map((feature, index) => (
                    <div
                      key={index}
                      className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow"
                    >
                      <div className="flex items-start">
                        <div className="flex-shrink-0 text-blue-600 mt-1 mr-4">
                          <FiCheckCircle className="w-5 h-5" />
                        </div>
                        <div>
                          <h3 className="font-semibold text-gray-900">
                            {feature}
                          </h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Benefits */}
            {product.benefits?.length > 0 && (
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-2 border-b border-gray-200">
                  Business Benefits
                </h2>
                <div className="space-y-4">
                  {product.benefits?.map((benefit, index) => (
                    <div key={index} className="flex items-start">
                      <div className="flex-shrink-0 text-green-500 mt-1 mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <p className="text-gray-700">{benefit}</p>
                    </div>
                  ))}
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPage;
